import React from 'react';

function Intro2() {
  return (
    <section className="page-intro-cerv section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 bord-thin-right rest">
            <div className="row justify-content-end rest">
              <div className="col-md-5 rest">
                <div className="cont">
                  <div className="mb-40">
                    <h2 className="fz-100 numb-font">1.</h2>
                  </div>
                  <h4>Our Mission</h4>
                  <div className="text mt-30">
                    <p>
                      To bridge critical gaps in health, education, cultural literacy,
                      and economic opportunity across Nigerian communities — delivering
                      grassroots programmes that create lasting, human-positive impact.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5 rest">
                <div className="img fit-img bord-thin-left">
                  <img src="/light/assets/imgs/spob/spob-2.jpg" alt="SPOB mission" />
                </div>
              </div>
            </div>
            <div className="row justify-content-end bord-thin-top rest">
              <div className="col-md-5 rest">
                <div className="img fit-img">
                  <img src="/light/assets/imgs/spob/spob-3.jpg" alt="SPOB vision" />
                </div>
              </div>
              <div className="col-md-5 rest">
                <div className="cont bord-thin-left">
                  <div className="mb-40">
                    <h2 className="fz-100 numb-font">2.</h2>
                  </div>
                  <h4>Our Vision</h4>
                  <div className="text mt-30">
                    <p>
                      A Nigeria where every citizen has access to quality healthcare,
                      education, and the tools needed to thrive — where cultural
                      heritage is preserved and communities lead their own development.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 rest">
            <div className="bord-thin-top mt-100 position-re">
              <div className="row">
                <div className="col-md-11">
                  <div className="cont">
                    <div className="mb-40">
                      <h2 className="fz-100 numb-font">3.</h2>
                    </div>
                    <h4>Why SPOB?</h4>
                    <div className="text mt-30">
                      <p>
                        We work directly inside communities, not above them.
                        Every programme is designed with local input, verified
                        by measurable outcomes, and sustained by volunteer
                        networks who live the mission every day.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="bg-dots bg-img"
                data-background="/light/assets/imgs/patterns/dots.png"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro2;
